import { useState } from "react";
import BaseDrawer from "@/shared/components/Drawer";
import CategoryManagerPanel, { CategoryManagerImportButton } from "./CategoryManagerPanel";
import type { CategoryManagerPanelProps } from "./CategoryManagerPanel";

// ADM-621 : le contenu vit désormais dans CategoryManagerPanel, partagé avec la
// page Budget. Ce composant n'est plus que la coquille drawer.
type CategoryManagerDrawerProps = CategoryManagerPanelProps & {
  open: boolean
  onOpenChange: (open: boolean) => void
  bankMovementId: string
};

const CategoryManagerDrawer = ({
  open,
  onOpenChange,
  ...panelProps
}: CategoryManagerDrawerProps) => {
  const [importOpen, setImportOpen] = useState(false);

  return (
    <BaseDrawer
      drawerId="DRW-CATMGR"
      open={open}
      onOpenChange={onOpenChange}
      isFirstLevel={false}
      onBack={() => onOpenChange(false)}
      width="893px"
      zIndex={70}
      bodyClassName="[&_*]:select-text"
      title="Gérer les catégories"
      description={`Budget ${panelProps.selectedSimpleBudgetType} - désactiver ou supprimer`}
      headerIndicator={(
        <div className="flex justify-end">
          <CategoryManagerImportButton onClick={() => setImportOpen(true)} />
        </div>
      )}
    >
      <CategoryManagerPanel {...panelProps} importOpen={importOpen} setImportOpen={setImportOpen} />
    </BaseDrawer>
  );
};

export default CategoryManagerDrawer;
